<template>
  <el-dialog
    title="申请提现"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :width="dialogWidth"
    :z-index="2000"
    @close="handleClose"
  >
    <el-form
      :model="form"
      :rules="rules"
      ref="withdrawForm"
      label-width="120px"
    >
      <div class="withdraw-item" style="flex-direction: row;">
        <span>可用金额: </span>
        <span>{{ balance }}</span>
      </div>
      <el-form-item label="提现金额:" prop="amount">
        <el-input
          v-model="form.amount"
          placeholder="请输入"
          @input="onInput"
          type="number"
          style="width: 200px;"
        />
      </el-form-item>
      <el-form-item label="选择收款网络:" prop="network">
        <el-select
          v-model="form.network"
          placeholder="请选择"
          class="filter-item"
          clearable
        >
          <el-option label="bsc" value="bsc" />
        </el-select>
      </el-form-item>
      <el-form-item label="选择收款地址:" prop="address">
        <el-input
          v-model="form.address"
          placeholder="请输入"
          style="width: 200px;"
        />
      </el-form-item>

      <el-form-item label="验证码:" prop="smsCode">
        <el-cell :span="12" style="display: flex; align-items: center;">
          <el-input
            v-model="form.smsCode"
            placeholder="请输入"
            style="width: 200px; margin-right: 10px;"
          />
          <el-button
            type="primary"
            @click="onSendSmsCode"
            :disabled="!canSendSms || countdown > 0"
          >
            {{ sendSmsLabel }}
          </el-button>
        </el-cell>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="saveData" :loading="btnLoading">
        确定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getBankListQuery } from "@/api/account-profit";
import { sendSmsCode } from "@/api/common";
import { withdraw } from "@/api/dashboard";
import { getTableThumbnailImg } from "@/utils/utils";
import { getLogionUserInfo } from "@/utils/auth"; // 验权
import { AGENT_LOGIN_ROLE_VAL } from "@/utils/enumUtile";
export default {
  name: "WithdrawDialog",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    balance: {
      type: Number,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      btnLoading: false,
      form: {
        amount: null,
        network: "",
        address: "",
        smsCode: "",
        coinCode: "TBC",
      },
      rules: {
        amount: [
          { required: true, message: "请输入提现金额", trigger: "blur" },
        ],
        smsCode: [{ required: true, message: "请输入验证码", trigger: "blur" }]
      },
      selectBank: {},
      isAgentLogin: null,
      agentUserId: "",
      sendSmsLabel: "获取验证码",
      countdown: 0, // 添加：倒计时秒数
      timer: null, // 添加：定时器引用
      canSendSms: true, // 添加：控制按钮是否可点击
    };
  },
  computed: {
    dialogWidth() {
      return window.innerWidth <= 768 ? "92%" : "60%";
    },
    AGENT_LOGIN_ROLE_VAL() {
      return AGENT_LOGIN_ROLE_VAL;
    },
  },
  created() {
    this.isAgentLogin = getLogionUserInfo().isAgentLogin;
    this.agentUserId =
      (this.isAgentLogin == AGENT_LOGIN_ROLE_VAL.AGENT && this.disabled) ||
      this.isAgentLogin == AGENT_LOGIN_ROLE_VAL.AGENT_ADMIN
        ? this.agentDetail?.agentUserId
        : getLogionUserInfo()?.agentUserId;
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },

  methods: {
    getTableThumbnailImg,
    onSendSmsCode() {
      // 防止重复点击
      if (!this.canSendSms || this.countdown > 0) return;

      // 设置初始倒计时
      this.countdown = 60;
      this.canSendSms = false;
      this.sendSmsLabel = `${this.countdown}秒后重新发送`;

      // 启动定时器
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown > 0) {
          this.sendSmsLabel = `${this.countdown}秒后重新发送`;
        } else {
          // 倒计时结束
          clearInterval(this.timer);
          this.timer = null;
          this.sendSmsLabel = "重新发送";
          this.canSendSms = true;
        }
      }, 1000);
      // 调用发送接口
      sendSmsCode({
        mobile: getLogionUserInfo()?.mobile,
        type: "withdraw"
      })
        .then((res) => {
          if (res && res.bizcode === 100) {
            this.$message({
              message: "验证码发送成功",
              type: "success",
            });
          } else {
            // 发送失败时重置状态（可选：根据需求决定是否保留倒计时）
            this.$message({
              message: res.msg || "验证码发送失败",
              type: "error",
            });
            // 如果发送失败也想让用户重试，可以取消注释下面代码
            // clearInterval(this.timer);
            // this.timer = null;
            // this.countdown = 0;
            // this.sendSmsLabel = "获取验证码";
            // this.canSendSms = true;
          }
        })
        .catch(() => {
          // 请求异常时重置
          clearInterval(this.timer);
          this.timer = null;
          this.countdown = 0;
          this.sendSmsLabel = "获取验证码";
          this.canSendSms = true;
        });
    },

    onInput() {
      if (this.form.amount > this.balance) {
        this.form.amount = this.balance;
      }
      if (this.form.amount < 0) {
        this.form.amount = 0;
      }
    },
    handleClose() {
      this.$emit("close");
    },
    saveData() {
      this.$refs.withdrawForm.validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          withdraw(this.form).then((resp) => {
            if (resp && resp.bizcode === 100) {
              this.btnLoading = false;
              this.handleClose();
              this.$emit("save");
            } else {
              this.btnLoading = false;
            }
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.withdraw-item {
  display: flex;
  align-items: center;
  height: 60px;
  > span {
    &.label {
      width: 120px;
      text-align: right;
      margin-right: 10px;
      font-weight: bold;
      color: #333;
      font-size: 15px;
      white-space: nowrap;
    }
    &.value {
      font-size: 15px;
      color: #333;
      display: flex;
      align-items: center;
      flex: 1;
      min-width: 0;
    }
  }
  ::v-deep .el-input {
    width: 200px;
  }
  ::v-deep .el-select {
    width: 200px;
  }
  ::v-deep .el-image {
    width: 40px;
    height: 40px;
    margin-right: 8px;
  }
}

.withdraw-bank {
  width: 100%;
  max-width: 500px;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 15px 20px;
  margin: 0 auto;
  background-color: #f9f9f9;
  .withdraw-item {
    height: auto;
    min-height: 40px;
    margin-bottom: 8px;
    &:last-child {
      margin-bottom: 0;
    }
    > span {
      &.label {
        width: 80px;
        font-size: 14px;
        padding-right: 10px;
      }
      &.value {
        font-size: 14px;
      }
    }
  }
}

// 添加截断文本样式
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  max-width: 200px;
}

.bank-name {
  white-space: nowrap;
}

// 响应式样式
@media screen and (max-width: 768px) {
  .withdraw-item {
    flex-direction: column;
    align-items: flex-start;
    height: auto;
    // min-height: 60px;
    padding: 10px 0;

    > span {
      &.label {
        width: 100%;
        text-align: left;
        margin-right: 0;
        margin-bottom: 8px;
        font-size: 14px;
      }
      &.value {
        width: 100%;
        font-size: 14px;
      }
    }

    ::v-deep .el-input,
    ::v-deep .el-select {
      width: 100%;
    }
  }

  .withdraw-bank {
    width: 100%;
    margin: 10px 0;
    padding: 12px 15px;
    background-color: #fff;

    .withdraw-item {
      min-height: 40px;
      padding: 8px 0;
      flex-direction: row;
      align-items: center;

      > span {
        &.label {
          width: 80px;
          margin-bottom: 0;
          font-size: 13px;
        }
        &.value {
          flex: 1;
          font-size: 13px;
        }
      }
    }
  }

  // 移动设备上调整截断文本宽度
  .truncate {
    max-width: calc(100vw - 220px);
  }

  // 确保el-dialog在移动端正确显示
  ::v-deep .el-dialog {
    max-height: 90vh;
    overflow-y: auto;
    margin: 10vh auto !important;
  }
  ::v-deep .el-dialog__body {
    padding: 10px 20px;
  }
}

@media screen and (max-width: 480px) {
  .withdraw-item {
    padding: 8px 0;
  }

  .withdraw-bank {
    padding: 10px;
    border-radius: 8px;
  }

  .truncate {
    max-width: calc(100vw - 180px);
  }

  ::v-deep .el-dialog {
    width: 95% !important;
    margin: 5vh auto !important;
    max-height: 90vh;
  }
}
</style>
